<template>
    <div class="page">
        <p class="page_title">404 page not found</p>
        <span class="error-hint" @click="$router.replace({ path: '/' })">
            返回首页
        </span>
    </div>
</template>
<script>
export default {
    name: "ErrorPage404",
};
</script>
<style  scoped>
.page {
    background: #303133;
    background-blend-mode: multiply, multiply;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 60vh;
    text-align: center;
    font-size: 60px;
    font-weight: 600;
}
.page .page_title {
    font-size: 20px;
    color: #fff;
}
.error-hint {
    display: inline-block;
    position: relative;
    margin-top: 25vh;
    font-weight: 400;
    cursor: pointer;
    transform: rotate(-3deg);
    border-bottom: 5px solid rgb(68, 93, 235);
    color: #fff;
}
.error-hint::after {
    content: "";
    position: absolute;
    left: -30px;
    top: -20px;
    right: -30px;
    bottom: -30px;
    border: 8px dashed rgb(81, 195, 230);
    border-radius: 6px;
}
</style>